import { render, staticRenderFns } from "./OrgSaasRedemptionDashboard.vue?vue&type=template&id=28734e40"
import script from "./OrgSaasRedemptionDashboard.vue?vue&type=script&lang=js"
export * from "./OrgSaasRedemptionDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports